module.exports = __webpack_public_path__ + "img/404.7bf657bc.png";